import { createAsyncThunk } from '@reduxjs/toolkit';
import { _auditUrls } from '@custom/Utils/constants/apiUrls';

const teleradiologistAuditLogsApi = createAsyncThunk('Teleradiologist Audit Logs', async (obj:any) => {
  try {
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    let url = `${_auditUrls.teleradiologistList}`
    let response = await fetch(url, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
      body:JSON.stringify(obj)
    })
    return await response.json()
  } catch (error) {
    return error;
  }
});

export default teleradiologistAuditLogsApi;
